import { render, staticRenderFns } from "./AgencyPricesDialog.vue?vue&type=template&id=059036e0&scoped=true&"
import script from "./AgencyPricesDialog.vue?vue&type=script&lang=ts&"
export * from "./AgencyPricesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AgencyPricesDialog.vue?vue&type=style&index=0&id=059036e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059036e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VContainer,VForm,VRow,VSelect,VSwitch,VTextField})
